import { AxiosResponse } from "axios";
import { apisiseci } from "./api";

export const getAtendimentos = (
  token: string,
  params?: {
    hoje?: boolean;
    anteriores?: boolean;
    page?: number;
    data?: string;
    status?:
      | "Aguardando"
      | "Em Atendimento"
      | "Pendente"
      | "Finalizado"
      | "Cancelado";
    guiche_id: string;
  },
): Promise<AxiosResponse> =>
  apisiseci.get("atendimento/atendimentos/", {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  });

export const updateStatusAtendimento = (
  token: string,
  id: string,
  status:
    | "Aguardando"
    | "Em Atendimento"
    | "Pendente"
    | "Finalizado"
    | "Cancelado"
    | "Não Compareceu",
  guiche: string
): Promise<AxiosResponse> =>
  apisiseci.put(
    `atendimento/atendimentos/${id}/?guiche_id=${guiche}`,
    {
      id,
      status,
      guiche,
    },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

export const getAtendimento = (
  token: string,
  id: string,
  guiche_id: string,
): Promise<AxiosResponse> =>
  apisiseci.get(`atendimento/atendimentos/${id}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
    params: {
      guiche_id,
    },
  });

  export const sendReply = (
    token: string,
    id: string,
    message: string,
    haveAnexo?: boolean
  ): Promise<AxiosResponse> =>
    apisiseci.post(
      "atendimento/responder/",
      {
        topico: id,
        conteudo: message,
        anexo: haveAnexo,
      },
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    );


export const attachFilesOnReply = (
  token: string,
  titulo: string,
  descricao: string,
  arquivo: File,
  resposta: string
): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append("titulo", titulo);
  formData.append("descricao", descricao);
  formData.append("arquivo", arquivo);
  formData.append("resposta", resposta);
  return apisiseci.post("atendimento/anexar_resposta/", formData, {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Token ${token}`,
    },
  });
};

export const markAsRead = (token: string, replayId: number): Promise<AxiosResponse> =>
  apisiseci.put(
    `atendimento/marcar_resposta/${replayId}/`,
    {
      lido: true,
    },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

export const addObservationAttendence = (
  token: string,
  id: string,
  observation: string
): Promise<AxiosResponse> =>
  apisiseci.post(
    `atendimento/observacao/`,
    {
      topico: id,
      conteudo: observation,
    },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );